import { lazy } from "react";
import { IGaiaObjectsProps } from "./definitions"; // import the correct type

const LazyGaiaObjects = lazy(() => import("./GaiaObjects"));

const GaiaObjects = (props: IGaiaObjectsProps) => (
  <LazyGaiaObjects {...props} />
);

export default GaiaObjects;
